import { CurrentDossierProvider, useDefaultContextActions } from '@europrocurement/l2d-modules';
import { Container } from '@mui/material';
import React from 'react';
import { useDumbActionsContext } from '@europrocurement/flexy-components';
import { useParams } from 'react-router';
import { DossierAddFormality } from '../../components';

const AddFormality: React.FunctionComponent = function () {
    const { idDossier } = useParams();
    const { backContextActions } = useDefaultContextActions();
    useDumbActionsContext(backContextActions);
    if (!idDossier) {
        console.log(`Dossier non trouvé paramètres url:  ${idDossier}`);
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
    }
    return (
        <CurrentDossierProvider
            autoload
            idDossier={idDossier}
        >
            <Container maxWidth="md">
                <DossierAddFormality />
            </Container>
        </CurrentDossierProvider>
    );
};

export default AddFormality;
